import AppMode from "../api/enums/AppMode";
import { routes } from "../routes/routes";
import { localStorageKeys } from "./localStorageKeys";

export const appModeChangedEventName = "appModeChanged";

const promoterUserTypes = new Set(["Promoter", "1"]);

const getNormalizedUserType = (userType: unknown): string => `${userType ?? ""}`;

export const isPromoterUserType = (userType: unknown): boolean =>
  promoterUserTypes.has(getNormalizedUserType(userType));

export const getDefaultAppModeForUser = (userType: unknown): AppMode =>
  isPromoterUserType(userType) ? AppMode.PromoterMode : AppMode.GuestMode;

export const getStoredAppModeOrUndefined = (): AppMode | undefined => {
  const storedValue = localStorage.getItem(localStorageKeys.appMode);

  if (storedValue === AppMode.GuestMode || storedValue === AppMode.PromoterMode) {
    return storedValue;
  }

  return undefined;
};

export const getStoredAppMode = (): AppMode => {
  return getStoredAppModeOrUndefined() ?? AppMode.GuestMode;
};

export const setStoredAppMode = (appMode: AppMode): void => {
  localStorage.setItem(localStorageKeys.appMode, appMode);
  window.dispatchEvent(new CustomEvent(appModeChangedEventName, { detail: appMode }));
};

export const initializeAppModeForLogin = (userType: unknown): AppMode => {
  const defaultAppMode = getDefaultAppModeForUser(userType);
  setStoredAppMode(defaultAppMode);
  return defaultAppMode;
};

export const getRouteForAppMode = (appMode: AppMode): string => {
  return appMode === AppMode.PromoterMode ? routes.PromotersMode : routes.GuestMode;
};

export const getPostLoginRouteForUser = (userType: unknown): string => {
  return getRouteForAppMode(getDefaultAppModeForUser(userType));
};

export const ensureValidAppModeForUser = (userType: unknown): AppMode => {
  const storedAppMode = getStoredAppModeOrUndefined();

  if (!isPromoterUserType(userType)) {
    setStoredAppMode(AppMode.GuestMode);
    return AppMode.GuestMode;
  }

  if (storedAppMode) {
    return storedAppMode;
  }

  const defaultAppMode = AppMode.PromoterMode;
  setStoredAppMode(defaultAppMode);
  return defaultAppMode;
};
